import type { MagentoStoreConfig } from "@jti/fe-common";
import { keysToCamelCase } from "@jti/fe-common";

import type { StoreConfig } from "../../endpoints/getStoreConfigEndpoint";

/**
 * Builds the RTK Query cache value for the "getStoreConfig" endpoint from a raw,
 * snake_case storeConfig response. Used with `upsertQueryEntries`, which writes the
 * value directly into the cache without re-running `transformResponse` (unlike
 * `upsertQueryData`), so the value must already be in the endpoint's result shape.
 */
export const normalizeStoreConfigResponse = (storeConfig: MagentoStoreConfig): StoreConfig => ({
  __typename: "StoreConfig",
  id: null,
  ...keysToCamelCase(storeConfig),
  cartonsLimitValue: storeConfig.cartons_limit_value ?? null,
});
